import React, { useEffect, useState } from 'react';
import { bootstrapSession, redirectToLogin } from './auth';
import { supabase } from './supabase';
import Header from './components/Header';
import Dashboard from './components/Dashboard';

export default function App() {
  const [authState, setAuthState] = useState({ status: 'loading' });
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await bootstrapSession();
      if (cancelled) return;
      if (!result.ok) {
        setAuthState({ status: 'unauthenticated', reason: result.reason });
        redirectToLogin();
        return;
      }
      setAuthState({ status: 'authenticated', user: result.user });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (authState.status !== 'authenticated') return;
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('users')
        .select('id, name, email, role')
        .eq('id', authState.user.id)
        .maybeSingle();
      if (cancelled) return;
      setProfile(data || null);
    })();
    return () => {
      cancelled = true;
    };
  }, [authState]);

  if (authState.status === 'loading') {
    return (
      <div className="login-redirect">
        <p>Checking your session…</p>
      </div>
    );
  }

  if (authState.status === 'unauthenticated') {
    return (
      <div className="login-redirect">
        <p>Redirecting to login…</p>
      </div>
    );
  }

  const userForUi = {
    id: authState.user.id,
    email: authState.user.email,
    name: profile?.name || authState.user.user_metadata?.name || authState.user.email,
    role: profile?.role,
  };

  return (
    <div className="app">
      <Header user={userForUi} />
      <Dashboard user={userForUi} />
    </div>
  );
}
